import { FC } from 'react';
import { Loading } from '../../components/loaders';
import { DataSourcesRouter } from '../../features/dataSources';
import { Assistant, AssistantFeatureGate } from '../assistant';
import { AudiencesRouter } from '../audiences';
import { CampaignsRouter } from '../campaigns';
import CompanyCreation from '../company/components/CompanyCreation';
import CyclrAuthRedirect from '../cyclr/CyclrAuthRedirect';
import { DestinationsRouter } from '../destinations';
import { HomePage } from '../home';
import Logout from '../logout/Logout';
import { PrivateRoute } from '../router/components';
import RouteConstants from '../router/RouteConstants';
import { SettingsRouter } from '../settings';
import { UnifiedProfilesRouter } from '../unifiedProfiles';
import { useUserInfo } from '../userInfo/hooks';
import WorkspaceCreation from '../workspaceEdit/WorkspaceCreation';

export const LayoutRoutes: FC = () => {
  const userInfo = useUserInfo();

  return (
    <>
      <PrivateRoute path={RouteConstants.logout} component={Logout} />
      {!userInfo.onboard ? (
        <Loading />
      ) : (
        <>
          <PrivateRoute path={RouteConstants.home} component={HomePage} />
          <PrivateRoute path={RouteConstants.campaigns} component={CampaignsRouter} />
          <PrivateRoute path={RouteConstants.createCompany} component={CompanyCreation} />
          <PrivateRoute path={RouteConstants.createWorkspace} component={WorkspaceCreation} />
          <PrivateRoute path={RouteConstants.dataSources} component={DataSourcesRouter} />
          <PrivateRoute path={RouteConstants.audiences} component={AudiencesRouter} />
          <PrivateRoute path={RouteConstants.unifiedProfiles} component={UnifiedProfilesRouter} />
          <PrivateRoute path={RouteConstants.destinations} component={DestinationsRouter} />
          <PrivateRoute path={RouteConstants.settings} component={SettingsRouter} />
          <PrivateRoute path={RouteConstants.cyclrAuthRedirect} component={CyclrAuthRedirect} />

          <AssistantFeatureGate>
            <Assistant />
          </AssistantFeatureGate>
        </>
      )}
    </>
  );
};
